import React from 'react'
import styled from '@emotion/styled'
import cn from 'classnames'
import modalStyles from 'components/Modal/styles-desktop.css'
import Content from './Content'

const CannedRepliesModal = React.forwardRef(
  ({ className, hideModal, modalLeft, ...rest }, forwardedRef) => {
    return (
      <Content
        hideModal={hideModal}
        className={cn(className, modalStyles.content)}
        {...rest}
        innerRef={forwardedRef}
      />
    )
  }
)

export default styled(CannedRepliesModal)`
  display: flex;
`
